export default {
	syncFailures: {
		subtitle: 'Overview of the data transfer from the ERP system',
		tabOverview: 'Overview',
		tabFailures: 'Errors',
		tabUpdates: 'Recent updates',
		filterModule: 'Module',
		lastUpdateAt: 'Last update: {date}',
		colModule: 'Module',
		colErpId: 'ERP no.',
		colProblem: 'Problem',
		colRecord: 'Record',
		colChangedFields: 'Changed fields',
		colTime: 'Time',
		copyErpId: 'Copy ERP no.',
		copiedErpId: 'ERP no. {id} copied to clipboard',
		detailsTitle: 'Technical details',
		detailsReason: 'Original message',
		detailsShowReason: 'Show original message',
		detailsHideReason: 'Hide original message',
		detailsCode: 'Error code',
		detailsSyncRun: 'Sync run',
		detailsInternalId: 'Internal entry',
		detailsErpInternalId: 'ERP internal ID',
		retryRow: 'Retry',
		retryAll: 'Retry all (filtered)',
		retryPending: 'Retry pending',
		retryAllCount: 'Retry all {count}',
		retryConfirmTitle: 'Mark sync failures for retry',
		retryConfirmBodyRow:
			'Should this sync entry be retried on the next sync run?',
		retryConfirmBodyBulk:
			'Should {count} sync entries be retried on the next sync run? The transfer takes effect on the next sync run, not immediately.',
		retrySuccessRow: '{count} entry marked for retry.',
		retrySuccessBulk: '{count} entries marked for retry.',
		showChain: 'Show related errors',
		chainTitle: 'Related errors',
		chainCausedBy: 'Caused by',
		chainCurrent: 'This error',
		chainCauses: 'Causes follow-up errors',
		chainSiblings: 'Related entries',
		chainEmpty: 'This error is not related to any other errors.',
		truncationHint:
			'Showing the newest {count} entries. Use the filters to narrow down the selection.',
		diffOld: 'Before',
		diffNew: 'After',
		diffEmpty: '(empty)',
		requestBodyTitle: 'Submitted data',
		versionNotice:
			'Complete sync error data requires at least sync version {version}. This version is currently being rolled out.',
		fields: {
			hp_id: 'ERP no.',
			person_id: 'Person',
			building_id: 'Property',
			unit_id: 'Unit',
			description: 'Description',
			type_id: 'Type',
			zip: 'ZIP',
			city: 'City',
			country: 'Country',
			street: 'Street',
			name: 'Name',
			number: 'Number',
			created: 'Created',
			updated: 'Updated',
			deleted: 'Deleted',
		},
		selfHealingHint: 'entries are cleaned up automatically',
		selfHealingShow: 'show',
		selfHealingHide: 'hide',
		emptyFailuresTitle: 'No sync errors',
		emptyFailuresText:
			'All data was transferred successfully from the ERP system.',
		emptyUpdates: 'No updates recorded.',
		emptyFiltered: 'No entries for the current filter selection.',
		analysis: {
			dependency: {
				title: 'Waiting for a linked record',
				action:
					'The linked record must exist and be transferred in the ERP system first. This entry is then pulled in automatically.',
				actionWithDep:
					'The linked record {dependency} must exist and be transferred in the ERP system first. This entry is then pulled in automatically.',
			},
			blocked: {
				title: 'Blocked by linked data',
				action:
					'The record is still used in the portal and therefore cannot be {operation}. Remove the link in the ERP system first; the transfer is then retried automatically.',
				actionRemoved:
					'After several attempts the record could not be {operation} because it is still in use, and it was removed from the queue. Remove the link in the ERP system and edit the record again so it is transferred anew.',
			},
			self_healing: {
				title: 'Cleaned up automatically',
				action:
					'No action needed: the record does not (or no longer) exist in the portal. The entry is cleaned up automatically on the next sync.',
			},
			missing_file: {
				title: 'Linked file not found',
				action:
					'The file linked to this entry no longer exists in the file system. Please check whether the file is present in the ERP system / archive. No support needed.',
			},
			temporary: {
				title: 'Temporary problem',
				action:
					'Temporary server or connection problem. The transfer is retried automatically, no action needed.',
			},
			invalid_data: {
				title: 'Data invalid or incomplete',
				action:
					'The data was rejected by the portal. Please check and correct the record in the ERP system (e.g. missing required fields). Rejected fields are listed below where available.',
			},
			validationErrorsTitle: 'Rejected fields',
			conflict: {
				title: 'Possible data conflict',
				action:
					'Possibly a duplicate. Please check the record in the ERP system for duplicate entries.',
			},
			auth: {
				title: 'Sync service sign-in failed',
				action:
					'The sync service could not sign in or is missing permissions. Please contact support.',
			},
			config: {
				title: 'Technical configuration problem',
				action:
					'An internal configuration problem prevents the transfer. Please contact support with the technical details (see below).',
			},
			unknown: {
				title: 'Transfer error',
				action:
					'The transfer failed. Please review the technical details. If the error keeps occurring, contact support.',
			},
			operationGeneric: 'processed',
			operations: {
				Create: 'created',
				Read: 'read',
				Update: 'updated',
				Delete: 'deleted',
			},
		},
		hpIdParts: {
			building: 'Building',
			accounting_year: 'Year',
			account_number: 'Account',
			sequence_number: 'Sequence no.',
			payment_part: 'Payment part',
			primanota: 'Primanota',
			journal_number: 'Journal',
			line_item: 'Line item',
			address_number: 'Address',
			email_index: 'Email index',
		},
		modules: {
			address: 'Address',
			building: 'Building',
			building_address: 'Building address',
			unit: 'Unit',
			role: 'Role',
			person: 'Person',
			user: 'User',
			propertymanager: 'Property manager',
			building_type: 'Building type',
			building_group_header: 'Building group',
			building_group_value: 'Building group value',
			building_garage_type: 'Garage type',
			building_heating_type: 'Heating type',
			building_trashbarrel_type: 'Trash barrel type',
			building_hotwater_type: 'Hot water type',
			building_type_building_group_value: 'Building type / group link',
			rolepermission: 'Role permission',
			phonenumber: 'Phone number',
			email: 'Email address',
			communication_type: 'Communication type',
			document_type: 'Document type',
			document_file: 'Document file',
			document_container: 'Document',
			document_building: 'Document link (building)',
			document_unit: 'Document link (unit)',
			document_person: 'Document link (person)',
			document_cis: 'Document link (C.I.S.)',
			document_task: 'Document link (task)',
			document_craftsmantask: 'Document link (craftsman task)',
			user_client: 'User account',
			team: 'Team',
			team_user: 'Team member',
			cis: 'C.I.S.',
			cis_building: 'C.I.S. link (building)',
			cis_unit: 'C.I.S. link (unit)',
			cis_person: 'C.I.S. link (person)',
			cis_type: 'C.I.S. type',
			task: 'Task',
			task_building: 'Task link (building)',
			task_unit: 'Task link (unit)',
			task_person: 'Task link (person)',
			task_type: 'Task type',
			craftsmantask: 'Craftsman task',
			craftsmantask_type: 'Craftsman task type',
			craftsmantask_status: 'Craftsman task status',
			craftsmantask_process: 'Craftsman task process',
			craftsmantask_status_text: 'Craftsman task status text',
			craftsmantask_person: 'Craftsman task person',
			craftsmantask_person_contact: 'Craftsman task contact',
			craftsmantask_person_type: 'Craftsman task person type',
			craftsmantask_building: 'Craftsman task link (building)',
			craftsmantask_unit: 'Craftsman task link (unit)',
			craftsmantask_task: 'Craftsman task link (task)',
			craftsmantask_cis: 'Craftsman task link (C.I.S.)',
			none: 'General',
			building_group_building: 'Building group / building link',
			meter: 'Meter',
			meter_type: 'Meter type',
			meter_devicetype: 'Meter device type',
			meter_manufacturer: 'Meter manufacturer',
			meter_level: 'Meter reading',
			meter_consumption: 'Consumption',
			accounting_year: 'Accounting year',
			account_name: 'Account name',
			account_balance: 'Account balance',
			account: 'Account',
			account_person: 'Account link (person)',
			journal: 'Journal entry',
			vendor_account: 'Vendor account',
			invoice: 'Invoice',
			review_document: 'Document review',
			review_document_account: 'Document review account',
			review_document_account_name: 'Document review account name',
			review_document_account_balance: 'Document review account balance',
			review_document_journal: 'Document review journal entry',
			review_document_account_link: 'Document review account link',
			update_request: 'Data change request',
			note: 'Note',
			handover_protocol: 'Handover protocol',
			client: 'Client',
		},
	},
}
